const FAMILY_OFFICE_URL = 'https://familyoffice.globalcitizenconsult.com';

export default function FamilyOfficePanel() {
  return (
    <section
      id="family-office"
      data-testid="family-office-section"
      className="relative py-12 md:py-16 bg-[#f7f6f3]"
    >
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div
          data-testid="family-office-panel"
          className="bg-white border-l-4 border-[#1a7a7a] rounded-[3px] p-6 md:p-8 flex flex-col min-[700px]:flex-row min-[700px]:items-center min-[700px]:justify-between gap-6 min-[700px]:gap-10"
          style={{ fontFamily: "'Montserrat', sans-serif" }}
        >
          <div>
            <p
              data-testid="family-office-eyebrow"
              className="text-gray-500 uppercase text-xs tracking-[0.14em] mb-3 font-medium"
            >
              Family Office Practice
            </p>
            <h2
              data-testid="family-office-heading"
              className="text-xl md:text-2xl font-semibold text-[#1a2332] mb-3"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              For families setting up a family office
            </h2>
            <p
              data-testid="family-office-copy"
              className="text-gray-500 text-base leading-relaxed max-w-[62ch]"
            >
              A dedicated practice led by the co-founders, for families whose lives, companies and assets sit in more than one country. Direct access, from the first conversation to the last signature.
            </p>
          </div>
          <a
            href={FAMILY_OFFICE_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="family-office-link"
            className="text-[#1a7a7a] font-semibold text-[15px] hover:text-[#1a6868] transition-colors duration-300 whitespace-nowrap shrink-0"
          >
            Visit the Family Office practice →
          </a>
        </div>
      </div>
    </section>
  );
}
